import { Container, Title } from '@mantine/core';

export const Home = () => {
  return (
    <Container>
      <Title>Home</Title>
    </Container>
  );
};
